import { SVGProps } from 'react';

export const IconSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.577 7.296 2.05 1.075a.702.702 0 0 0-.782.102.78.78 0 0 0-.232.357.818.818 0 0 0-.014.433L2.45 8l-1.428 6.033a.817.817 0 0 0 .014.433.78.78 0 0 0 .232.358.7.7 0 0 0 .783.101l12.525-6.222a.75.75 0 0 0 .308-.286.81.81 0 0 0 0-.834.75.75 0 0 0-.308-.287ZM2.829 12.819l.618-2.61 4.185-2.21-4.185-2.208-.618-2.61L12.532 8 2.83 12.819Z'
      fill='currentColor'
    />
  </svg>
);
